import script from "./water.vue?vue&type=script&lang=ts&setup=true"
export * from "./water.vue?vue&type=script&lang=ts&setup=true"

import "./water.vue?vue&type=style&index=0&id=d8b854d6&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8b854d6"]])

export default __exports__